module.exports = __webpack_public_path__ + "static/RiceFlour-d927ca0a1d3e2ff59c4bc094ec6ab362.webp";